import { useState } from 'react';

import WalletTopup from '../topup/WalletTopup';
import TopupSuccess from '../topup/TopupSuccess';
export default function TopupwalletPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="TopupwalletPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
            </div>
            <div className="sm:col-12 comp-grid" >
                <div className="">
                    <div><WalletTopup /></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
